import React, { useEffect, useState } from "react";
import Personal from "../Patient/Personal";
import ContactDetails from "../Patient/ContactDetails";
import EmergencyContact from "../Patient/EmergencyContact";
import MedicalRecord from "../Patient/MedicalRecord";
import { useParams } from "react-router-dom";
import { get } from "../../utility/fetch";
import VisitTable from "../tables/VisitTable";
import ImmunizationTable from "../tables/ImmunizationTable";
import Treatments from "../Patient/Treatments";
import Labs from "../Patient/Labs";
import AppointmentTable from "../tables/AppointmentTable";
import MedicalHistory from "../modals/MedicalHistory";
import Discounts from "../Patient/Discounts";
import Procedure from "../Patient/Procedures";
import MedicalLog from "../Patient/MedicalLogs";
import FullHmoPage from "./FullHmoPage";
import axios from "axios";
import { CircularProgress, Box } from "@mui/material";

function PatientDetails({ visibleTabs = [] }) {
  const [selectedTab, setSelectedTab] = useState("personal");
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);
  const { patientId } = useParams();
  const [visit, setVisit] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [id, setId] = useState(null);
  const [hmoDetails, setHmoDetails] = useState(null);
  const [hmoLoading, setHmoLoading] = useState(false);

  const switchToTab = (tab) => {
    setSelectedTab(tab);
  };

  const getPatientDetails = async () => {
    setLoading(true);
    try {
      const data = await get(`/patient/${patientId}`);
      setPatient(data?.data);
      console.log(data?.data);
      console.log(data?.data);

      // setVisit(data?.visits?.pop());
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  const fetchPatientHMO = async () => {
    setHmoLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const baseUrl = process.env.REACT_APP_BASE_URL;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const financeToken = sessionStorage.getItem("financeToken") || token;
      const financeConfig = {
        headers: {
          Authorization: `Bearer ${financeToken}`,
          "Content-Type": "application/json",
        },
      };

      // Fetch HMO list
      const backendBase = process.env.REACT_APP_BACKEND_URL_FINANCE;
      let hmoList = null;
      try {
        const listRes = await axios.get(
          `${backendBase}/hmo/list/1/100`,
          financeConfig,
        );
        hmoList = listRes?.data?.resultList || listRes?.data || null;
      } catch (listErr) {
        console.warn("Failed to fetch HMO list:", listErr);
      }

      // Fetch patient HMO data
      const patientRes = await axios.get(
        `${baseUrl}/medicals/api/HMO/get-patient-hmo/${15700}?pageIndex=1&pageSize=10`,
        config,
      );

      if (
        patientRes.data &&
        patientRes.data.data &&
        patientRes.data.data.length > 0
      ) {
        const patientHmo = patientRes.data.data[0];
        const membershipValidity = new Date(patientHmo.membershipValidity);
        const today = new Date();
        const isActive = membershipValidity >= today;

        const hmoData = {
          ...patientHmo,
          provider: null,
          package: null,
          isActive,
          membershipValidityDate: membershipValidity,
        };

        // Match HMO provider from list
        if (hmoList && Array.isArray(hmoList)) {
          const matchedHmo = hmoList.find(
            (item) => item.id === patientHmo.hmoProviderId,
          );
          if (matchedHmo) {
            hmoData.provider = matchedHmo;

            // Match package
            if (
              patientHmo.hmoPackageId &&
              matchedHmo.packages &&
              Array.isArray(matchedHmo.packages)
            ) {
              const matchedPackage = matchedHmo.packages.find(
                (pkg) => pkg.id === patientHmo.hmoPackageId,
              );
              if (matchedPackage) {
                hmoData.package = matchedPackage;
              }
            }
          }
        }

        setHmoDetails(hmoData);
      }
    } catch (error) {
      console.error("Error fetching patient HMO:", error);
    } finally {
      setHmoLoading(false);
    }
  };

  useEffect(() => {
    getPatientDetails();
  }, []);

  useEffect(() => {
    if (selectedTab === "HMO" && !hmoDetails && !hmoLoading) {
      fetchPatientHMO();
    }
  }, [selectedTab]);

  const renderTabContent = () => {
    switch (selectedTab) {
      case "personal":
        return <Personal data={patient} />;
      case "contactDetails":
        return <ContactDetails data={patient?.contact} />;
      case "emergencyContact":
        return (
          <EmergencyContact
            data={patient?.emergencyContact}
            next={() => switchToTab("medicalRecord")}
          />
        );
      case "medicalRecord":
        return (
          <MedicalRecord
            data={patient.medicalRecords}
            next={() => switchToTab("immunization")}
            fetchData={getPatientDetails}
            patientId={patientId}
          />
        );
      case "visits":
        return (
          <VisitTable
            patientId={patientId}
            next={() => switchToTab("treatment")}
          />
        );
      case "immunization":
        return <ImmunizationTable patientId={patientId} />;
      case "treatment":
        return (
          <Treatments
            data={patient?.treatments}
            visit={visit || null}
            id={patientId}
          />
        );
      case "appointments":
        return (
          <AppointmentTable
            patientId={patientId}
            next={() => switchToTab("labs")}
          />
        );
      case "specialty":
        return <MedicalLog patient={patient} />;
      case "HMO":
        if (hmoLoading) {
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 5,
              }}
            >
              <CircularProgress />
            </Box>
          );
        }
        if (!hmoDetails) {
          return (
            <Box sx={{ textAlign: "center", py: 5 }}>
              <p>No HMO information available for this patient.</p>
            </Box>
          );
        }
        return <FullHmoPage hmoDetails={hmoDetails} />;
      case "labs":
        return <Labs visit={visit} id={patientId} />;
      case "discounts":
        return <Discounts id={patientId} />;
      case "procedures":
        return (
          <Procedure
            id={patientId}
            name={`${patient?.firstName} ${patient?.lastName}`}
          />
        );
      default:
        return null;
    }
  };

  const handlePatientId = () => {
    console.log(patientId);
    setId(patientId);
    setShowHistory(true);
  };

  return (
    <div className="w-100">
      {loading ? (
        <div className="m-t-40">
          <h1>Loading......</h1>
        </div>
      ) : (
        <>
          {patient ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <h1
                  style={{ fontSize: "clamp(1.1rem, 4vw, 1.5rem)", margin: 0 }}
                >
                  {patient?.firstName + " " + patient?.lastName}
                </h1>
                <button
                  onClick={handlePatientId}
                  className="btn"
                  style={{
                    fontSize: "clamp(0.75rem, 2.5vw, 0.9rem)",
                    padding: "8px 12px",
                    whiteSpace: "nowrap",
                  }}
                >
                  View Medical History
                </button>
              </div>

              <div
                className="tabs m-t-20 bold-text w-100"
                style={{
                  display: "flex",
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                  gap: "5px",
                  paddingBottom: "5px",
                }}
              >
                {visibleTabs.includes("personal") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "personal" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("personal")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Personal
                  </div>
                )}
                {visibleTabs.includes("contactDetails") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "contactDetails" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("contactDetails")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Contact Details
                  </div>
                )}
                {visibleTabs.includes("emergencyContact") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "emergencyContact" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("emergencyContact")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Emergency Contact
                  </div>
                )}
                {visibleTabs.includes("medicalRecord") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "medicalRecord" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("medicalRecord")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Medical Record
                  </div>
                )}
                {visibleTabs.includes("immunization") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "immunization" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("immunization")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Immunization
                  </div>
                )}
                {visibleTabs.includes("visits") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "visits" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("visits")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Vitals
                  </div>
                )}
                {visibleTabs.includes("treatment") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "treatment" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("treatment")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Treatment
                  </div>
                )}
                {visibleTabs.includes("appointments") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "appointments" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("appointments")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Appointments
                  </div>
                )}

                {visibleTabs.includes("specialty") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "specialty" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("specialty")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Specialty
                  </div>
                )}
                {visibleTabs.includes("HMO") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "HMO" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("HMO")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    HMO
                  </div>
                )}
                {visibleTabs.includes("labs") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "labs" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("labs")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Labs
                  </div>
                )}
                {visibleTabs.includes("procedures") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "procedures" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("procedures")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Procedures
                  </div>
                )}
                {visibleTabs.includes("discounts") && (
                  <div
                    className={`tab-item ${
                      selectedTab === "discounts" ? "active" : ""
                    }`}
                    onClick={() => switchToTab("discounts")}
                    style={{
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.7rem, 2.5vw, 0.9rem)",
                      padding: "8px 12px",
                      flexShrink: 0,
                    }}
                  >
                    Discounts
                  </div>
                )}
              </div>
              <div className="w-100" style={{ padding: "0 10px" }}>
                {renderTabContent()}
              </div>
            </>
          ) : (
            <div className="m-t-40 bold-text p-40">
              <h1>Patient not found</h1>
            </div>
          )}
        </>
      )}

      {showHistory && (
        <MedicalHistory
          patientId={id}
          closeModal={() => setShowHistory(false)}
        />
      )}
    </div>
  );
}

export default PatientDetails;
